import React, { Component } from "react";

import { StaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image';

import './consumers.css';

class Consumers extends Component {
    render() {
      return (
		  
		<StaticQuery
		  
		query={
		  graphql`
			query {
				payNowLogo: file(relativePath: { eq: "PayNow.png" }) {
					childImageSharp {
						fixed(width: 100) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
			  qrCode: file(relativePath: { eq: "qr-code.png" }) {
				childImageSharp {
					fluid(maxWidth: 500, quality: 100) {
					...GatsbyImageSharpFluid
					}
				}
			},
			  paylahLogo: file(relativePath: { eq: "apps/paylah.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  ocbcLogo: file(relativePath: { eq: "apps/ocbc.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  uobLogo: file(relativePath: { eq: "apps/uob.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  citiBankLogo: file(relativePath: { eq: "apps/citi-bank.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  hsbcLogo: file(relativePath: { eq: "apps/hsbc.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  standardCharteredLogo: file(relativePath: { eq: "apps/standard-chartered.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  maybankLogo: file(relativePath: { eq: "apps/maybank.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
			  bocLogo: file(relativePath: { eq: "apps/bank-of-china.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },				
			  icbcLogo: file(relativePath: { eq: "apps/icbc.jpg" }) {
				  childImageSharp {
					  fluid(maxWidth: 500, quality: 100) {
					  ...GatsbyImageSharpFluid
					  }
				  }
			  },
		  }`
		}

		render={data=>(
			<div>
				<header className="section header">
					<div className="shape-wrapper">
							<div className="shape shape-background shape-main"></div>
							<div className="shape shape-background shape-top"></div>
					</div>
					<div className="container overflow-hidden">
						<div className="row align-items-center first-section">
							<div className="col-md-6 col-lg-6">
								<h5 className="font-lg">No fuss. Just scan.</h5>
								<p className="lead">Use <a href="https://www.abs.org.sg/consumer-banking/pay-now" rel="noreferrer" target="_blank"><Img loading="eager" fixed={data.payNowLogo.childImageSharp.fixed}  alt="PayNow" className="paynow-logo-inline"/></a> to shop online!</p>
							</div>
						</div>
					</div>
					<div className="section cards">
						<div className="container">
							<div className="container-xl">
								<span className="consumer-card normal-card">
									<div className="card-title">
										<div className="icon"><span role="img" aria-label="Lightning Quick">⚡️</span></div>
										<h5 className="mt-0 mb-1"><strong>Quick</strong><div id="quick" className="main"></div></h5>
									</div>
									<ul>
										<li className="m-0">No need to type anything</li>
										<li className="m-0">No need to create an account</li>
									</ul>
								</span>
								<span className="consumer-card normal-card">
									<div className="card-title">
										<div className="icon"><span role="img" aria-label="Transparent">💸</span></div>
										<h5 className="mt-0 mb-1"><strong>Transparent</strong><div id="transparent"className="main"></div></h5>
									</div>
									<ul>
										<li className="m-0">Know if the payment was successful</li>
										<li className="m-0">See the transaction in your bank app's overview</li>
									</ul>
								</span>
								<span className="consumer-card normal-card">
									<div className="card-title">
										<div className="icon"><span role="img" aria-label="Secure">🔐</span></div>
										<h5 className="mt-0 mb-1"><strong>Safe</strong><div id="safe" className="main"></div></h5>
									</div>
									<ul>
										<li className="m-0">Transactions are secured with bank-grade security</li>
									</ul>
								</span>
							</div>
						</div>
					</div>
				</header>
				<section id="how-does-it-work" className="section">
					<div className="container text-center">
						<div className="section-heading text-center">
							<h2 className="font-lg" style={{color: "#5d3edc"}}>How does it work?</h2>
						</div>
						<div className="row">
							<div className="col-md-6 mt-5">
								<h5 className="mb-3">Scan QR & Pay (Desktop)</h5>
								<div className="embed-responsive embed-responsive-16by9">
									<iframe title="How Maesh works on Desktop" class="embed-responsive-item" src="https://www.youtube.com/embed/UkS-E89RSJM" allowfullscreen></iframe>
								</div>
							</div>
							<div className="col-md-6 mt-5">
								<h5 className="mb-3">Upload QR & Pay (Mobile)</h5>
								<div className="embed-responsive embed-responsive-16by9">
									<iframe title="How Maesh works on Mobile" class="embed-responsive-item" src="https://www.youtube.com/embed/dimxUtYCbxI" allowfullscreen></iframe>
								</div>
							</div>
						</div>
						<div className="text-center">
						</div>
					</div>
				</section>
				<section id="participating-banks">
					<div className="container">
						<div className="text-center" style={{position: "relative"}}>
							<h2 style={{fontWeight: "bold"}} className="lead text-center">Banks participating in PayNow</h2>
							<div style={{margin:"15px"}}>
								<Img fluid={data.paylahLogo.childImageSharp.fluid} alt="PayLah! logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.ocbcLogo.childImageSharp.fluid} alt="OCBC Bank logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.uobLogo.childImageSharp.fluid} alt="UOB logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.citiBankLogo.childImageSharp.fluid} alt="Citi Bank logo"
									className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.hsbcLogo.childImageSharp.fluid} alt="HSBC logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.standardCharteredLogo.childImageSharp.fluid} alt="Standard Chartered logo"
									className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.maybankLogo.childImageSharp.fluid} alt="Maybank logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.bocLogo.childImageSharp.fluid} alt="Bank of China logo"
									className="mt-2 mb-2 ml-2 mr-2 banks"/>
								<Img fluid={data.icbcLogo.childImageSharp.fluid} alt="ICBC logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
							</div>
						</div>			
					</div>

				</section>
			</div>
      )}/>
	  )
	}
}

export default Consumers;
